import EndWorkShiftDialog, {
  EndWorkShiftDialogProps,
} from "@/components/serviceFlow/clockin/workShiftDialog/endWorkShiftDialog";
import StartWorkShiftDialog, {
  StartWorkShiftDialogProps,
} from "@/components/serviceFlow/clockin/workShiftDialog/startWorkShiftDialog";

export enum WorkShiftDialogType {
  START = "start",
  END = "end",
}

export default function WorkShiftDialog(
  props: StartWorkShiftDialogProps | EndWorkShiftDialogProps
) {
  if (props.type === WorkShiftDialogType.START) {
    return <StartWorkShiftDialog {...props} />;
  } else {
    return <EndWorkShiftDialog {...props} />;
  }
}
